// extracted by mini-css-extract-plugin
export default {"list":"SettingsItem_list__C7+3r","title":"SettingsItem_title__FMXkS"};